import noodleApiClient from '@/tsClient/servers/noodleApi';
import type { PaginatedResponse } from '@/typings/api';
import type { CaseEntityListItem } from '@/typings/api-models';

type Input = {
  caseId: string;
  entityType?: string;
  page?: number;
  perPage?: number;
};

const getCaseEntities = async ({
  caseId,
  entityType,
  page,
  perPage,
}: Input): Promise<PaginatedResponse<CaseEntityListItem>> => {
  const params = new URLSearchParams();
  if (entityType) params.set('entityType', entityType);
  if (page != null) params.set('page', String(page));
  if (perPage != null) params.set('perPage', String(perPage));

  const qs = params.toString();
  const url = `/cases/${caseId}/entities${qs ? `?${qs}` : ''}`;
  const response = await noodleApiClient.get(url);
  return response.data as PaginatedResponse<CaseEntityListItem>;
};

export default getCaseEntities;
